import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import app_45redirect_45global from "/opt/build/repo/middleware/app-redirect.global.js";
import authenticated_45global from "/opt/build/repo/middleware/authenticated.global.js";
import old_45path_45redirect_45global from "/opt/build/repo/middleware/old-path-redirect.global.ts";
import setup_45mode_45global from "/opt/build/repo/middleware/setup-mode.global.js";
import track_45page_45visit_45global from "/opt/build/repo/middleware/track-page-visit.global.js";
import track_45previous_45route_45global from "/opt/build/repo/middleware/track-previous-route.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  app_45redirect_45global,
  authenticated_45global,
  old_45path_45redirect_45global,
  setup_45mode_45global,
  track_45page_45visit_45global,
  track_45previous_45route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "can-create-change-order": () => import("/opt/build/repo/middleware/can-create-change-order.ts"),
  "can-create-po": () => import("/opt/build/repo/middleware/can-create-po.js"),
  "can-get-quotes": () => import("/opt/build/repo/middleware/can-get-quotes.js"),
  "can-manage-company": () => import("/opt/build/repo/middleware/can-manage-company.js"),
  "can-manage-users": () => import("/opt/build/repo/middleware/can-manage-users.js"),
  "clear-auth-token": () => import("/opt/build/repo/middleware/clear-auth-token.js"),
  "signup-enabled": () => import("/opt/build/repo/middleware/signup-enabled.js"),
  staff: () => import("/opt/build/repo/middleware/staff.js")
}